import { useQuery } from "@tanstack/react-query"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import { axios } from "../axios"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { API_SBP_COMBINED_PAYMENTS_BY_ID_URL } from "../constants"
import { ROUTES_PATHS } from "../../utils/constants"
import { setPaymentResult } from "../../store/slices/payment"
import { PaymentStatusResponse } from "../../types/payments"

const getPaymentStatus = async (combinedPaymentId: string, token: string) => {
  const response = await axios(
    `${API_SBP_COMBINED_PAYMENTS_BY_ID_URL}/${combinedPaymentId}?includeTransactions=true`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при получении статуса платежа: ${response.status} - ${response.statusText}`,
    )
  }

  return response.data
}

export const usePaymentStatus = (combinedPaymentId: string | null) => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const token = useSelector((state: RootState) => state.auth.token)

  const query = useQuery<PaymentStatusResponse>({
    queryKey: ["payment-status", combinedPaymentId],
    queryFn: () => {
      setIsLoading(true)
      return getPaymentStatus(combinedPaymentId || "", token || "")
    },
    enabled: Boolean(combinedPaymentId) && Boolean(token),
    refetchInterval: (data) => {
      const status = data?.state?.data?.status
      if (["CreateError", "Accepted", "Rejected", "AcceptError"].includes(status || "")) {
        // Сохраняем результат в store
        dispatch(setPaymentResult(data?.state?.data!))

        // Редиректим на соответствующую страницу
        navigate(
          `/${ROUTES_PATHS.topUpMbankAccountPayments}/${
            status === "Accepted" ? "success" : "error"
          }`,
        )
        return false
      }
      return 1000 // опрашиваем каждую секунду
    },
  })

  return { query, isLoading }
}
